import {
  GetPillarColorFragment,
  MaturityLevel,
  PriorityLevel,
  ThemeColor,
} from '@/graphql/generated';

export function getPillarColor(
  pillar: GetPillarColorFragment | null | undefined,
): string {
  return getThemeLightColor(pillar?.color);
}

export function getThemeLightColor(
  themeColor: ThemeColor | null | undefined,
): string {
  switch (themeColor) {
    case ThemeColor.Gray:
      return 'bg-gray-50';
    case ThemeColor.Green:
      return 'bg-green-50';
    case ThemeColor.Purple:
      return 'bg-purple-50';
    case ThemeColor.Blue:
      return 'bg-blue-50';
    case ThemeColor.Red:
      return 'bg-red-50';
    case ThemeColor.Yellow:
      return 'bg-yellow-50';
    default:
      return 'bg-gray-50';
  }
}

export function getMaturityLevelFromComputedValue(
  computedValue: number | null | undefined,
): MaturityLevel | null {
  if (typeof computedValue !== 'number' || computedValue < 0) {
    return null;
  }

  if (computedValue > 3) {
    return MaturityLevel.High;
  }
  if (computedValue > 2) {
    return MaturityLevel.Medium;
  }
  if (computedValue > 1) {
    return MaturityLevel.Low;
  }
  return MaturityLevel.None;
}

export function getPriorityLevelFromComputedValue(
  computedValue: number,
): PriorityLevel | null {
  if (computedValue < 0) {
    return null;
  }

  if (computedValue > 3) {
    return PriorityLevel.High;
  }
  if (computedValue > 2) {
    return PriorityLevel.Medium;
  }
  if (computedValue > 1) {
    return PriorityLevel.Low;
  }
  return PriorityLevel.None;
}
